import { type ListStyle } from '@meitu/saas-editor-core/es/version-types';

export const LIST_MARKER_SIZE_RANGE = {
    min: 0.6,
    max: 1.3,
    step: 0.1,
};

export const NORMAL_LIST_STYLES: Record<Exclude<ListStyle, '' | 'custom'>, string> = {
    decimal: `1. 2. 3.`,
    'lower-latin': `a. b. c.`,
    'upper-roman': `Ⅰ. Ⅱ. Ⅲ.`,
    disc: `● ● ●`,
    circle: `○ ○ ○`,
    square: `■ ■ ■`,
};
